import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    CheckCircleIcon,
    colors,
    WarningIcon
} from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { FILE_UPLOAD_STATUS } from "shared";

import { StatusIconProps } from "../types";

const StatusIcon = ({ uploadStatus }: StatusIconProps) => {
    const { green600, orange600 } = colors;

    const { t } = useTranslation();

    const isSuccess = uploadStatus === FILE_UPLOAD_STATUS.Success;

    return (
        <TooltipGeneral
            placement={TOOLTIP_PLACEMENT.Top}
            title={
                isSuccess
                    ? t("Dropzone##file successfully uploaded")
                    : t("Dropzone##error uploading the file")
            }
        >
            <span
                css={css({
                    "& > svg": { fontSize: "24px", margin: "6px 6px 1px 6px" }
                })}
            >
                {isSuccess ? (
                    <CheckCircleIcon css={css({ color: green600 })} />
                ) : (
                    <WarningIcon css={css({ color: orange600 })} />
                )}
            </span>
        </TooltipGeneral>
    );
};

export default StatusIcon;
